<template>
    <div class="ckeditor">
        <textarea
                :name="name"
                :id="id"
                :value="value"
                :types="types"
                :config="config"
        >
        </textarea>
    </div>
</template>

<script>
    let inc = new Date().getTime();

    export default {
        name: 'vue-ckeditor',
        props: {
            name: {
                type: String,
                default: () => `editor-${++inc}`
            },
            value: {
                type: String
            },
            id: {
                type: String,
                default: () => `editor-${inc}`
            },
            types: {
                type: String,
                default: () => `classic`
            },
            config: {
                type: Object,
                default: () => {}
            }
        },
        data () {
            return { destroyed: false }
        },
        computed: {
            instance () {
                return CKEDITOR.instances[this.id]
            }
        },
        watch: {
            value (val) {
                if (this.instance) {
                    this.update(val)
                }
            }
        },
        mounted () {
            this.create();

            let thisData = this;

            setTimeout(function(){
                thisData.update(thisData.value);
            }, 3000);
        },
        beforeDestroy () {
            this.destroy()
        },
        methods: {
            create () {
                let $vm = this;
                if (typeof CKEDITOR === 'undefined') {
                    console.log('CKEDITOR is missing (http://ckeditor.com/)');
                } else {
                    // CKEDITOR.plugins.addExternal('ckeditor_wiris', 'https://www.wiris.net/demo/plugins/ckeditor/', 'plugin.js');
                    CKEDITOR.plugins.addExternal('ckeditor_wiris', '/static/assets/js/ckeditor/plugins/ckeditor_wiris/', 'plugin.js');

                    if (this.types === 'inline') {
                        CKEDITOR.inline(this.id, this.config);
                    } else {
                        CKEDITOR.replace(this.id, this.config);
                    }

                    this.instance.setData(this.value);
                    this.instance.on('change', this.onChange);
                    this.instance.on('blur', this.onBlur);
                    this.instance.on('focus', this.onFocus);
                    this.instance.on('key', function (e) {
                        if (e.data.keyCode === 13) {
                            $vm.addMessage();
                        }else{
                            $vm.onTyping();
                        }
                    });
                }
            },
            update (val) {
                let html = this.instance.getData();
                if (html !== val) {
                    this.instance.setData(val)
                }
            },
            destroy () {
                if (!this.destroyed) {
                    this.instance.focusManager.blur(true);
                    this.instance.removeAllListeners();
                    this.instance.destroy();
                    this.destroyed = true
                }
            },
            onChange () {
                let html = this.instance.getData();
                if (html !== this.value) {
                    this.$emit('input', html);
                }
            },
            onBlur () {
                this.$emit('blur', this.instance);
            },
            onFocus () {
                this.$emit('focus', this.instance);
            },
            addMessage(){
                this.$emit('addMessage');
                this.update('');
            },
            onTyping(){
                this.$emit('onTyping');
            }
        }
    }
</script>
<style>
    .ckeditor::after {
        content: "";
        display: table;
        clear: both;
    }
</style>
